"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.digitalSignatureComponents = exports.WithFileUtils = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

var _File = _interopRequireDefault(require("../components/file/File.form"));

var _Formio = _interopRequireDefault(require("../Formio"));

var _errorMessageIdGetters = require("./errorMessageIdGetters");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ReactDOM;
var React;
var CryptoUi;

try {
  ReactDOM = require('react-dom');
  React = require('react');
  CryptoUi = require('@platform/crypto-ui');
} catch (error) {
  console.error(error);
}

var _utils = require('./utils');

var WithFileUtils = function WithFileUtils(_WithFileUtils2, setting) {
  var baseUrl = setting.baseUrl;
  return (
    /*#__PURE__*/
    function (_WithFileUtils) {
      _inherits(_class, _WithFileUtils);

      _createClass(_class, null, [{
        key: "editForm",
        value: function editForm() {
          for (var _len = arguments.length, extend = new Array(_len), _key = 0; _key < _len; _key++) {
            extend[_key] = arguments[_key];
          }

          var form = _File.default.apply(void 0, [[{
            key: 'digitalSignature',
            label: 'Электронная подпись',
            components: [].concat(digitalSignatureComponents)
          }]].concat(extend));

          return form;
        }
      }]);

      function _class(component, options, data) {
        var _this2;

        _classCallCheck(this, _class);

        _this2 = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, component, options, data));

        if (component.signatureRequired) {
          _this2.validators = _this2.validators.concat(['signatureRequired']);
        } // Нужно для grid компонентов если использовать ReactDOM.render сразу в getView то React не будет работать
        // т.к вставляется пустая разметка через innerHTML


        _this2.addDigitalSignatureButtonPropsList = [];
        _this2.fileLoaded = new Promise(function (resolve, reject) {
          _this2.fileLoadedResolve = resolve;
          _this2.fileLoadedReject = reject;
        });
        return _this2;
      }

      _createClass(_class, [{
        key: "createFileListItem",
        value: function createFileListItem(isGetView, fileInfo, index) {
          var _this = this;

          var fileNameWithoutExt = _this.fileNameWithoutExt(fileInfo);

          var fileExt = _this.fileExt(fileInfo);

          var fileId = fileInfo.data.id;
          var isWithSignature = this.component.signatureEnabled;
          var fileItem = this.ce('li', {
            class: 'list-group-item list-group-item-file'
          }, [this.ce('div', {
            class: 'list-item',
            style: 'display: flex; width: 100%; align-items: center'
          }, [this.createBlockFileLink(baseUrl, fileInfo, [this.ce('span', {
            class: 'file-list__file-name',
            style: 'margin-right: 10px'
          }, [this.ce('span', {
            class: 'file-name__name'
          }, fileNameWithoutExt), this.ce('span', {
            class: 'file-name__ext'
          }, fileExt)], fileNameWithoutExt), this.ce('span', {
            class: 'file-list__file-size',
            style: 'white-space: nowrap'
          }, this.fileSize(fileInfo.size))]), !this.disabled && !this.shouldDisable ? this.ce('button', {
            class: 'file-list__file-remove icon-button',
            style: 'background: none; border: none',
            onClick: function onClick(event) {
              _this.splice(index);

              _this.refreshDOM();

              _this.triggerFileChange();

              event.preventDefault();

              _this.toggleSelectDisable();
            }
          }, this.ce('i', {
            class: 'theme-icon-trash'
          })) : null]), isWithSignature && this.ce('div', {
            id: "signature-".concat(fileId),
            title: '',
            style: 'margin-left: 20px'
          })]);

          if (isWithSignature) {
            var addDigitalSignatureButtonProps = {
              setting: setting,
              fileItem: fileItem,
              fileNameWithoutExt: fileNameWithoutExt,
              fileExt: fileExt,
              fileId: fileId,
              fileInfo: fileInfo,
              downloadFile: this.getDownloadFileFunction(baseUrl, fileInfo)
            };

            if (isGetView) {
              this.addDigitalSignatureButtonPropsList.push(addDigitalSignatureButtonProps);
            } else {
              this.addDigitalSignatureButton(addDigitalSignatureButtonProps);
            }
          }

          return fileItem;
        }
      }, {
        key: "addDigitalSignatureButton",
        value: function addDigitalSignatureButton(addDigitalSignatureButtonProps, isAfterGetView) {
          var _this3 = this;

          var setting = addDigitalSignatureButtonProps.setting,
              fileItem = addDigitalSignatureButtonProps.fileItem,
              fileNameWithoutExt = addDigitalSignatureButtonProps.fileNameWithoutExt,
              fileExt = addDigitalSignatureButtonProps.fileExt,
              fileId = addDigitalSignatureButtonProps.fileId,
              fileInfo = addDigitalSignatureButtonProps.fileInfo,
              downloadFile = addDigitalSignatureButtonProps.downloadFile;
          var materialUiTheme = setting.materialUiTheme,
              intlStore = setting.intlStore,
              signatureStore = setting.signatureStore;
          var containerWrapper = isAfterGetView ? document : fileItem;
          var container = containerWrapper.querySelector("#signature-".concat(fileId));

          if (materialUiTheme && intlStore && signatureStore && container && !container.hasChildNodes()) {
            var componentSettings = this.component;

            var onSuccess = function onSuccess(signatureStatus) {
              _this3.dataValue.some(function (file) {
                if (file.data.id === fileId) {
                  file.signatureStatus = signatureStatus;
                  return true;
                }
              });

              _this3.setValue(_this3.dataValue);

              _this3.triggerFileChange({
                modified: true
              });

              if (_this3.viewOnly) {
                var onSuccessForFormioInstance = signatureStore.onSuccessForFormioInstance;
                onSuccessForFormioInstance && onSuccessForFormioInstance();
              }
            };

            ReactDOM.render(React.createElement(CryptoUi.FileSignature, {
              isView: componentSettings.canEditViewMode ? false : this.viewOnly,
              theme: materialUiTheme,
              signatureSetting: {
                signatureEnabled: componentSettings.signatureEnabled,
                signatureBrowserPlugin: componentSettings.signatureBrowserPlugin,
                signatureRequired: componentSettings.signatureRequired,
                signatureUpload: componentSettings.signatureUpload
              },
              apiUrls: {
                getFileByteUrl: this.interpolate(componentSettings.getFileByteUrl, fileInfo),
                uploadSignatureUrl: this.interpolate(componentSettings.uploadSignatureUrl, fileInfo),
                uploadSignatureFileUrl: this.interpolate(componentSettings.uploadSignatureFileUrl, fileInfo),
                getSignatureInfoUrl: this.interpolate(componentSettings.getSignatureInfoUrl, fileInfo),
                downloadSignatureUrl: this.interpolate(componentSettings.downloadSignatureUrl, fileInfo),
                deleteSignatureUrl: this.interpolate(componentSettings.deleteSignatureUrl, fileInfo)
              },
              signatureStatus: fileInfo.signatureStatus || 'without',
              fileTitle: fileNameWithoutExt,
              fileExtension: fileExt,
              downloadFile: downloadFile,
              intlStore: intlStore,
              signatureStore: signatureStore,
              onSuccess: onSuccess
            }), container);
          }
        }
      }, {
        key: "setValidSignatureStatus",
        value: function setValidSignatureStatus(fileId) {
          var _this4 = this;

          return function (signatureStatus) {
            _this4.dataValue.some(function (file) {
              if (file.data.id === fileId) {
                file.signatureStatus = signatureStatus;
                return;
              }
            });

            _this4.setValue(_this4.dataValue);

            _this4.triggerFileChange({
              modified: true
            });
          };
        }
      }, {
        key: "createBlockFileLink",
        value: function createBlockFileLink(baseUrl, file, content) {
          if (this.options.uploadOnly) {
            return content;
          }

          var _this = this;

          var url = _this.getDownloadUrl(baseUrl, file);

          return this.ce('a', {
            href: url,
            target: '_blank',
            class: 'file-list__block-file-link',
            style: 'display: flex; justify-content: space-between; width: 100%; margin-right: 5px',
            onClick: _this.getDownloadFileFunction(baseUrl, file)
          }, content);
        }
      }, {
        key: "getDownloadFileFunction",
        value: function getDownloadFileFunction(baseUrl, file) {
          var _this = this;

          var url = _this.getDownloadUrl(baseUrl, file);

          return function (event) {
            event.preventDefault();

            _this.getFile(file, url);
          };
        }
      }, {
        key: "getDownloadUrl",
        value: function getDownloadUrl(baseUrl, file) {
          var path = file.url;
          var pathPrefix = path.startsWith('/') ? '' : '/';
          return path.startsWith('http') ? path : "".concat(baseUrl).concat(pathPrefix).concat(path);
        }
      }, {
        key: "buildFileList",
        value: function buildFileList(isGetView) {
          //Без шапки в списке файлов
          var _this = this;

          var value = this.dataValue;
          return this.ce('ul', {
            class: 'list-group list-group-striped'
          }, [Array.isArray(value) ? value.map(function (fileInfo, index) {
            return _this.createFileListItem(isGetView, fileInfo, index);
          }) : null]);
        }
      }, {
        key: "buildList",
        value: function buildList(isGetView) {
          if (this.component.image) {
            return this.buildImageList();
          } else {
            return this.buildFileList(isGetView);
          }
        }
      }, {
        key: "afterGetView",
        value: function afterGetView() {
          var _this5 = this;

          this.addDigitalSignatureButtonPropsList.forEach(function (addDigitalSignatureButtonProps) {
            _this5.addDigitalSignatureButton(addDigitalSignatureButtonProps, true);
          });
        }
      }, {
        key: "getView",
        value: function getView(value) {
          if (value.length) {
            this.dataValue = value;
            return this.buildList(true).innerHTML;
          }

          return '-';
        } //Изменения: переведены сообщения

      }, {
        key: "upload",
        value: function upload(baseUrl, files) {
          var _this = this; // Only allow one upload if not multiple.


          if (!this.component.multiple) {
            files = Array.prototype.slice.call(files, 0, 1);
          }

          if (this.component.storage && files && files.length) {
            // files is not really an array and does not have a forEach method, so fake it.
            Array.prototype.forEach.call(files, function (file) {
              var fileName = (0, _utils.uniqueName)(file.name);
              var fileUpload = {
                originalName: file.name,
                name: fileName,
                size: file.size,
                status: 'info',
                message: _this.t('uploadingStart')
              }; // Check file pattern

              if (_this.component.filePattern && !_this.validatePattern(file, _this.component.filePattern)) {
                fileUpload.status = 'error';
                fileUpload.message = _this.t('invalidFileType', {
                  type: _this.component.filePattern
                });
              } // Check file minimum size


              if (_this.component.fileMinSize && !_this.validateMinSize(file, _this.component.fileMinSize)) {
                fileUpload.status = 'error';
                fileUpload.message = _this.t('invalidFileMinSize', {
                  size: _this.component.fileMinSize
                });
              } // Check file maximum size


              if (_this.component.fileMaxSize && !_this.validateMaxSize(file, _this.component.fileMaxSize)) {
                fileUpload.status = 'error';
                fileUpload.message = _this.t('invalidFileMaxSize', {
                  size: _this.component.fileMaxSize
                });
              } // Get a unique name for this file to keep file collisions from occurring.


              var dir = _this.interpolate(_this.component.dir || '');

              var fileService = _this.fileService;

              if (!fileService) {
                fileUpload.status = 'error';
                fileUpload.message = _this.t('invalidFileService');
              }

              var uploadStatus = _this.createUploadStatus(fileUpload);

              _this.uploadStatusList.appendChild(uploadStatus);

              if (fileUpload.status !== 'error') {
                // Track uploads in progress.
                if (fileService.uploadsInProgress === undefined) {
                  var array = new Array();
                  fileService.uploadsInProgress = {
                    array: array,
                    add: function add(item) {
                      array.push(item);
                    },
                    remove: function remove(item) {
                      array.splice(array.indexOf(item), 1);
                    },
                    report: function report() {
                      var n = array.length;
                      var msg = 'Выполняется загрузка: '.concat(n);

                      if (n > 0) {
                        var keys = array.map(function (x) {
                          return x.component.key;
                        });
                        msg += ' ('.concat(keys.join(', '), ')');
                      }

                      console.log(msg);
                    }
                  };
                }

                var uploadsInProgress = fileService.uploadsInProgress;
                uploadsInProgress.add(_this); //uploadsInProgress.report();
                //

                if (_this.component.privateDownload) {
                  file.private = true;
                }

                var _this$component = _this.component;
                var storage = _this$component.storage;

                var path = _this.interpolate(_this$component.url, _this.evalContext());

                var pathPrefix = path.startsWith('/') ? '' : '/';
                var options = _this$component.options;
                var url = path.startsWith('http') ? path : "".concat(baseUrl).concat(pathPrefix).concat(path);

                if (_this$component.signatureEnable) {
                  var delimiter = url.indexOf('?') > -1 ? '&' : '?';
                  url = "".concat(url).concat(delimiter, "canBeSigned=").concat(_this$component.signatureEnabled);
                }

                fileService.uploadFile(storage, file, fileName, dir, function (evt) {
                  fileUpload.status = 'progress';
                  fileUpload.progress = parseInt(100.0 * evt.loaded / evt.total);
                  delete fileUpload.message;
                  var originalStatus = uploadStatus;
                  uploadStatus = _this.createUploadStatus(fileUpload);

                  _this.uploadStatusList.replaceChild(uploadStatus, originalStatus);
                }, url, options).then(function (fileInfo) {
                  _this.removeChildFrom(uploadStatus, _this.uploadStatusList); // Default to first type.


                  if (_this.hasTypes) {
                    fileInfo.fileType = _this.component.fileTypes[0].value;
                  }

                  var correctFileData = fileInfo.data;
                  fileInfo.originalName = correctFileData.name;
                  fileInfo.size = correctFileData.size;
                  fileInfo.signatureStatus = correctFileData.signatureStatus;

                  if (_this.categoryCode) {
                    fileInfo.category = _this.categoryCode;
                  }

                  var files = _this.dataValue;

                  if (!files || !Array.isArray(files)) {
                    files = [];
                  }

                  files.push(fileInfo);

                  _this.setValue(_this.dataValue); // Track uploads in progress.


                  uploadsInProgress.remove(_this); //uploadsInProgress.report();

                  _this.triggerFileChange();

                  _this.fileLoadedResolve();
                }).catch(function (xhr) {
                  if (_Formio.default.isOuterErrorHandlerSet()) {
                    _this.removeChildFrom(uploadStatus, _this.uploadStatusList);

                    var messageId = (0, _errorMessageIdGetters.getFileErrorMessageIdByStatus)(xhr.status);

                    _Formio.default.handleErrorWithOuterErrorHandler(messageId);
                  } else {
                    fileUpload.status = 'error';
                    var message = xhr.response || 'Unable to upload file';
                    fileUpload.message = message;
                    delete fileUpload.progress;
                    var originalStatus = uploadStatus;
                    uploadStatus = _this.createUploadStatus(fileUpload);

                    _this.uploadStatusList.replaceChild(uploadStatus, originalStatus);
                  }
                });
              }
            });
          }
        }
      }]);

      return _class;
    }(_WithFileUtils2)
  );
};

exports.WithFileUtils = WithFileUtils;
var digitalSignatureComponents = [{
  type: 'checkbox',
  input: true,
  weight: 0,
  key: 'signatureEnabled',
  label: 'Включить использование электронной подписи'
}, {
  type: 'checkbox',
  input: true,
  weight: 1,
  key: 'signatureRequired',
  label: 'Обязательно наличие подписи',
  conditional: {
    json: {
      var: 'data.signatureEnabled'
    }
  }
}, {
  type: 'checkbox',
  input: true,
  weight: 2,
  key: 'canEditViewMode',
  label: 'Подписание доступно в режиме просмотра',
  conditional: {
    json: {
      var: 'data.signatureEnabled'
    }
  }
}, {
  input: false,
  weight: 3,
  html: '<p><strong>Способы подписания</strong></p> ',
  type: 'content',
  conditional: {
    json: {
      var: 'data.signatureEnabled'
    }
  }
}, {
  type: 'checkbox',
  input: true,
  weight: 4,
  key: 'signatureBrowserPlugin',
  label: 'Плагин браузера',
  conditional: {
    json: {
      var: 'data.signatureEnabled'
    }
  },
  validate: {
    json: {
      if: [{
        or: [{
          var: 'data.signatureUpload'
        }, {
          var: 'data.signatureBrowserPlugin'
        }]
      }, true, ' ']
    }
  }
}, {
  type: 'checkbox',
  input: true,
  weight: 5,
  key: 'signatureUpload',
  label: 'Загрузка подписи или файла с прикреплённой подписью',
  conditional: {
    json: {
      var: 'data.signatureEnabled'
    }
  },
  validate: {
    json: {
      if: [{
        or: [{
          var: 'data.signatureUpload'
        }, {
          var: 'data.signatureBrowserPlugin'
        }]
      }, true, 'Выберите минимум один способ подписания']
    }
  }
}, {
  input: false,
  weight: 6,
  html: '<p><strong>Urls: </strong></p> ',
  type: 'content',
  conditional: {
    json: {
      var: 'data.signatureEnabled'
    }
  }
}, {
  type: 'textfield',
  input: true,
  weight: 7,
  key: 'getFileByteUrl',
  label: 'Получение байтов файла для генерации хэша',
  placeholder: '/request/file/{ { data.id } }/toByte',
  defaultValue: '/request/file/{{data.id}}/toByte',
  conditional: {
    json: {
      and: [{
        var: 'data.signatureEnabled'
      }, {
        var: 'data.signatureBrowserPlugin'
      }]
    }
  },
  validate: {
    required: true
  }
}, {
  type: 'textfield',
  input: true,
  weight: 8,
  key: 'uploadSignatureUrl',
  label: 'Подписание плагином',
  placeholder: '/request/file/{ { data.id } }/sign',
  defaultValue: '/request/file/{{data.id}}/sign',
  conditional: {
    json: {
      and: [{
        var: 'data.signatureEnabled'
      }, {
        var: 'data.signatureBrowserPlugin'
      }]
    }
  },
  validate: {
    required: true
  }
}, {
  type: 'textfield',
  input: true,
  weight: 9,
  key: 'uploadSignatureFileUrl',
  label: 'Подписание файлом',
  placeholder: '/request/file/{ { data.id } }/upload-sign',
  defaultValue: '/request/file/{{data.id}}/upload-sign',
  conditional: {
    json: {
      and: [{
        var: 'data.signatureEnabled'
      }, {
        var: 'data.signatureUpload'
      }]
    }
  },
  validate: {
    required: true
  }
}, {
  type: 'textfield',
  input: true,
  weight: 10,
  key: 'getSignatureInfoUrl',
  label: 'Информация о подписи',
  placeholder: '/request/file/{ { data.id } }/sign-info',
  defaultValue: '/request/file/{{data.id}}/sign-info',
  conditional: {
    json: {
      var: 'data.signatureEnabled'
    }
  },
  validate: {
    required: true
  }
}, {
  type: 'textfield',
  input: true,
  weight: 11,
  key: 'downloadSignatureUrl',
  label: 'Скачать подпись',
  placeholder: '/request/file/{ { data.id } }/sign',
  defaultValue: '/request/file/{{data.id}}/sign',
  conditional: {
    json: {
      var: 'data.signatureEnabled'
    }
  },
  validate: {
    required: true
  }
}, {
  type: 'textfield',
  input: true,
  weight: 12,
  key: 'deleteSignatureUrl',
  label: 'Удалить подпись',
  placeholder: '/request/file/{ { data.id } }/sign',
  defaultValue: '/request/file/{{data.id}}/sign',
  conditional: {
    json: {
      var: 'data.signatureEnabled'
    }
  },
  validate: {
    required: true
  }
}];
exports.digitalSignatureComponents = digitalSignatureComponents;